import { object, string } from 'yup'

export const addCategoriesSchema = object({
  value: string().required('فیلد نام دسته بندی الزامی است.'),
  color: string().required('فیلد رنگ دسته بندی الزامی است.'),
})
